<template>
  <v-card v-if="availablePrinters.length > 0">
    <v-card-title class="headline grey lighten-4">
      Print Label
    </v-card-title>
    <v-card-text>
      <v-row justify="center" class="ma-2">
        <v-img
          :src="labelPreview"
          max-width="600"
          max-height="400"
          class="ma-5"
        />
      </v-row>
      <v-form ref="form" v-model="valid">
        <v-select
          label="Choose Printer"
          :items="availablePrinters"
          :rules="rules"
          v-model="selectedPrinter"
          required
          prepend-icon="print"
          hint="If you don't see any printers you might not have DYMO 3.7 installed"
        />
        <v-text-field
          label="Material Name"
          v-model="labelContent.material"
          @blur="updateContent"
        >
        </v-text-field>
        <v-text-field
          label="Barcode"
          v-model="labelContent.barcode"
          @blur="updateContent"
        >
        </v-text-field>
        <v-text-field
          label="Weight"
          v-model="labelContent.weight"
          @blur="updateContent"
        >
        </v-text-field>
        <v-text-field
          label="Lot"
          v-model="labelContent.lot"
          @blur="updateContent"
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn :disabled="!valid" @click.native="print()">
        <v-icon left>print</v-icon>
        Print
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Dymo from "../../services/dymoPrint";
export default {
  name: "MaterialLabelPrint",
  props: {
    rawmaterial: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      selectedPrinter: false,
      valid: true,
      labelContent: {
        weight: this.rawmaterial.quantity,
        material: this.rawmaterial.material.name,
        lot: this.rawmaterial.lotnumber,
        barcode: this.rawmaterial.barcode
      },
      label: new Dymo({
        material: true
      }),
      labelPreview: "",
      rules: [value => !!value || "Required."]
    };
  },
  methods: {
    updateContent() {
      this.label.setMaterial(this.labelContent);
      this.label.setLot(this.labelContent);
      this.label.setWeight(this.labelContent);
      this.label.setCode(this.labelContent);
      this.labelPreview = this.label.getRender();
    },
    print() {
      this.label.printLabel(this.selectedPrinter);
    }
  },
  computed: {
    availablePrinters() {
      return this.label.getAvailablePrinters();
    }
  }
};
</script>
